import styled from 'styled-components';

import { Popover } from 'antd';

export const MainPopover = styled(Popover)``;